import { s16, s24 } from '@ardoq/design-tokens';

const LEGEND_SINGLE_REFERENCE_HEIGHT = 24;
export const LEGEND_CONTENT_HORIZONTAL_PADDING = s24;
export const LEGEND_CONTENT_VERTICAL_PADDING = s16;
export const LEGEND_ROW_HEADER_HEIGHT = 40;
export const LEGEND_ROW_BORDER_WIDTH = 1;
export const LEGEND_CONTENT_MIN_HEIGHT =
  LEGEND_SINGLE_REFERENCE_HEIGHT + // making sure at a minimum you can fit a single item in the smallest view legend
  2 * parseInt(LEGEND_CONTENT_VERTICAL_PADDING, 10) +
  2 * LEGEND_ROW_BORDER_WIDTH; // the scrollbar looks weird if the scrollable container grows smaller than its padding + borders
export const exportingViewLegendRowContentStyle = `
  display: flex;
  flex-direction: column;
  height: fit-content;
  width: 100%;
  padding: ${LEGEND_CONTENT_VERTICAL_PADDING}
    ${LEGEND_CONTENT_HORIZONTAL_PADDING};
  overflow: visible;
`;
